/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PolygonPointXY,
  WellAndFieldName,
  WellInfo,
  WellheadXYCoordinates,
  WellsAddParameters,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectWellsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение информации о скважинах проекта.
   * @request GET:/geology/project/{projectId}/wells/data
   * @secure
   */
  projectWellsGetWellsInProject = (projectId: string, params: RequestParams = {}) =>
    this.http.request<WellInfo[], any>({
      path: `/geology/project/${projectId}/wells/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение списка идентификаторов скважин месторождения (добавленных в проект)
   * @request GET:/geology/project/{projectId}/wells/for_field/{fieldId}
   * @secure
   */
  projectWellsGetWellsIdsInProjectForField = (
    projectId: string,
    fieldId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/wells/for_field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение списка идентификаторов скважин (добавленных в проект), входящих в заданный прямоугольник
   * @request GET:/geology/project/{projectId}/wells/for_rectangle/{minX}/{minY}/{maxX}/{maxY}
   * @secure
   */
  projectWellsGetWellsIdsInProjectForRectangle = (
    projectId: string,
    minX: number,
    minY: number,
    maxX: number,
    maxY: number,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/wells/for_rectangle/${minX}/${minY}/${maxX}/${maxY}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectWells
 * @summary Вернёт id скважин, у которых проекция траектории ствола на плоскость XY пересекается с заданным прямоугольником.
Координаты устья и инклинометрии учитываются совместно.
Использует закешированные граничные значения инклинометрии (WellAggrs) и индексы по координатам, 
работает быстро.
 * @request GET:/geology/project/{projectId}/wells/intersecting_rect/{minX}/{minY}/{maxX}/{maxY}
 * @secure
 */
  projectWellsGetWellIdsByRectangle = (
    projectId: string,
    minX: number,
    minY: number,
    maxX: number,
    maxY: number,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/wells/intersecting_rect/${minX}/${minY}/${maxX}/${maxY}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение списка идентификаторов скважин (добавленных в проект), входящих в заданный многоугольник
   * @request POST:/geology/project/{projectId}/wells/for_polygon
   * @secure
   */
  projectWellsGetWellsIdsInProjectForPolygon = (
    projectId: string,
    data: PolygonPointXY[],
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/wells/for_polygon`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение информации о скважинах месторождения (добавленных в проект)
   * @request GET:/geology/project/{projectId}/wells/for_field/{fieldId}/data
   * @secure
   */
  projectWellsGetWellsInProjectForField = (
    projectId: string,
    fieldId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<WellInfo[], any>({
      path: `/geology/project/${projectId}/wells/for_field/${fieldId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение устьевых координат по списку скважин проекта
   * @request POST:/geology/project/{projectId}/wells/xy
   * @secure
   */
  projectWellsGetWellheadXyCoordinates = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<WellheadXYCoordinates[], any>({
      path: `/geology/project/${projectId}/wells/xy`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение списка имен скважин и их месторождений скважин по проекту
   * @request GET:/geology/project/{projectId}/wells/well_names
   * @secure
   */
  projectWellsGetWellAndFieldNames = (projectId: string, params: RequestParams = {}) =>
    this.http.request<WellAndFieldName[], any>({
      path: `/geology/project/${projectId}/wells/well_names`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Получение словаря пар id всех активных проектных и непроектных скважин
   * @request GET:/geology/project/{projectId}/wells/idsMap
   * @secure
   */
  projectWellsGetProjectGridIdMap = (projectId: string, params: RequestParams = {}) =>
    this.http.request<Record<string, string>, any>({
      path: `/geology/project/${projectId}/wells/idsMap`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectWells
   * @summary Добавление скважин в проект по списку их идентификаторов
   * @request POST:/geology/project/{projectId}/wells
   * @secure
   */
  projectWellsAddWellsToProject = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/wells`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectWells
 * @summary Добавление скважин в проект по списку их идентификаторов для пользователя 
Используется для получения данных из GeoImport - в контексте запроса нет пользователя
 * @request POST:/geology/project/{projectId}/wells/forUser
 * @secure
 */
  projectWellsAddWellsToProjectForUser = (
    projectId: string,
    data: WellsAddParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/wells/forUser`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectWells
 * @summary Удаление скважин из проекта по набору ключей.
Вернёт количество реально удалённых скважин.
 * @request PATCH:/geology/project/{projectId}/wells/remove
 * @secure
 */
  projectWellsRemoveWellsFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/wells/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
